import "./alterbox.css"
import {useImperativeHandle, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useSession} from "../../redux/Reducers/AuthReducer";


function close() {
    document.getElementById("session-expired-modal").classList.remove("flex")
    document.getElementById("session-expired-modal").classList.add("hidden")
    document.getElementById("session-expired-modal-content").classList.remove("bottom-to-top-animation")

}

function open() {
    document.getElementById("session-expired-modal").classList.remove("hidden")
    document.getElementById("session-expired-modal").classList.add("flex")

    document.getElementById("session-expired-modal-content").classList.add("bottom-to-top-animation")
}

export function SessionExpiredModal({
                                        className,

                                        ...props
                                    }) {

    const navigate = useNavigate();
    const {authActions} = useSession();

    function onConfirm() {
        authActions.clearSession();
        navigate("/auth/login?next=" + window.location.pathname)
    }

    return (

        <div
            id={"session-expired-modal"}

            className={`hidden fixed inset-0 z-40  items-end bg-black bg-opacity-50 sm:items-center sm:justify-center appear-done enter-done ${className}`}>
            <div
                id={"session-expired-modal-content"}
                onClick={(e) => {
                    e.stopPropagation();
                }}
                className={` w-full px-6 py-4 overflow-hidden bg-white rounded-t-lg  sm:rounded-lg sm:m-4 sm:max-w-xl appear-done enter-done`}>
                <header className="flex justify-end">
                    <button
                        className="inline-flex items-center justify-center w-6 h-6 text-gray-400 transition-colors duration-150 rounded  hover: hover:text-gray-700"
                        aria-label="close">

                    </button>
                </header>
                <p className="mt-4 mb-2 text-xl font-semibold text-gray-700 ">
                    Session Expired
                </p>
                <div className="mb-6 text-base text-gray-700 ">
                    Please login again to continue
                </div>
                <div className={"flex text-black  flex-row-reverse gap-2 flex-1"}>
                    <button
                        onClick={() => {
                            if (onConfirm) onConfirm();
                            close()
                        }}
                        className={"flex-1 md:flex-none text-sm bg-secondary-900 hover:bg-secondary-800 px-6 py-2 rounded-lg  font-semibold text-white"}>
                        Login
                    </button>

                </div>
            </div>
        </div>

    )
}


const SessionModelActions = {
    open: open,
    close: close,
}

export default SessionModelActions;